import React from 'react';
import { useSelector } from 'react-redux';
import { headerIconStyles } from '../../../global/constants/theme/styles/components/header-icon-styles';
import { parseLov } from '../../../global/helpers/form-data-helper';
import { Person } from '../../../global/models/person-model';
import { TcsmStates } from '../../../root/tcsm-model';


function ClergyBioInfoHeader() {
	const headerClasses = headerIconStyles();

	const lovDesignations = useSelector<TcsmStates, any>(state => state.lovProcState?.personLov?.designation);
	const mappedDesignations = lovDesignations ? parseLov(lovDesignations) : [];
	const currentUser = useSelector<TcsmStates, Person>(state => state?.personalInfo?.myCPG.currentPerson);

	const designation = (currentUser?.designation && mappedDesignations?.length > 0) ? (mappedDesignations.find(d=> d.value === currentUser?.designation)?.text)?.trim() : '';	

	return (
		<div className={`${headerClasses.iconHeader} center`}>
			<svg className='clergy-icon clergy-icon-lg' aria-hidden='true' focusable='false'>
				<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#clergy-icon' />
			</svg>
			<h3>
				{designation} {currentUser?.first_name} {currentUser?.last_name}
			</h3>
		</div>
	);
}


export default ClergyBioInfoHeader;